import { useEffect, useMemo, useState } from 'react';
import { useLazyQuery, useQuery } from '@apollo/client';
import formatDataForSelect from 'Shared/util/formatDataForSelect';

const useSelectOptions = (data, dataKey, value) => {
  const [currentOption, setCurrentOption] = useState(null);

  useEffect(() => {
    if (!isNaN(+value)) {
      if (data) {
        const initialOption = data[dataKey].find(({ id }) => +id === +value);

        if (initialOption) {
          const { id, title } = initialOption;

          setCurrentOption({ id, label: title, value: title });
        }
      }
    } else {
      setCurrentOption(value);
    }
  }, [value, data]);

  const options = useMemo(() => formatDataForSelect(data ? data[dataKey] : []), [data, dataKey]);

  return {
    options,
    currentOption,
    setCurrentOption,
  };
};

const useSelectWithQueryOptions = (query, dataKey, value) => {
  const { data, refetch } = useQuery(query, {
    options: { cache: 'cache-only' },
  });

  const { options, currentOption, setCurrentOption } = useSelectOptions(data, dataKey, value);

  return {
    options,
    currentOption,
    setCurrentOption,
    refetch,
  };
};

const useSelectWithQueryOptionsLazy = (query, dataKey, value) => {
  const [getDataLazy, { data: dataLazy, refetch: refetchLazy }] = useLazyQuery(query, {
    options: { cache: 'cache-only' },
  });

  const { options, currentOption, setCurrentOption } = useSelectOptions(dataLazy, dataKey, value);

  return {
    options,
    currentOption,
    setCurrentOption,
    getDataLazy,
    refetchLazy,
  };
};

export { useSelectWithQueryOptionsLazy, useSelectWithQueryOptions };
